// @flow
export const ChartColors = [
  "#ffd700",
  "#4497d1",
  "#779b3e",
  "#fa832b",
  "#c0422c",
  "#7e7979"
];
